import UserActivityDropdown from '../../TrialUI/DataTableDropdowns/userActivityDropdown'

export default {
  tabs: {
    users: {
      title: 'User Activity',
      fetchKey: 'users',
      headers: [
        'nameNw',
        'email',
        'latestDate'
      ],
      dropdown: UserActivityDropdown
    }
  },
  app: {
    'xt_screen': 'XpertScreen',
    'xt_console': 'Admin-Console',
    // 'xperttrial': 'XpertTrial',
    'xt_dashboard': 'Admin-Dashboard'
  }
}
